import React from 'react'

import './FacebookPost.css'

function hostName(url) {
  if (!url) return;
  let hostname;

  if (url.indexOf("://") > -1) {
    hostname = url.split('/')[2];
  }
  else {
    hostname = url.split('/')[0];
  }

  //find & remove port number
  hostname = hostname.split(':')[0];
  //find & remove "?"
  hostname = hostname.split('?')[0];

  return hostname;
}

const FacebookPost = ({
  image,
  message,
  title,
  descr,
  url,
  isMobile,
}) => {
  const fbpost = isMobile ? 'fbpost fbpost--mobile' : 'fbpost';
  return (
    <div className={fbpost}>
      <div className="fbpost__type">Suggested Post</div>
      <div className="fbpost__header">
        <div className="fbpost__avatar"></div>
        <div className="fbpost__title">
          <div className="fbpost__page">Page Name</div>
          <div className="fbpost__meta">Sponsored</div>
        </div>
        <div className="fbpost__button">Like Page</div>
      </div>
      <div className="fbpost__message">{ message }</div>
      { url ? (
        <div className="fbpost__content">
          <div className="fbpost__preview">
            { image && <img className="fbpost__img" src={image} alt=""/> }
          </div>
          <div className="fbpost__descr">
            <div className="fbpost__link-title">{ title }</div>
            <div className="fbpost__link-descr">{ descr }</div>
            <div className="fbpost__link">
              <div className="fbpost__link-url">{ hostName(url) || 'URL' }</div>
              <div className="fbpost__button">Learn More</div>
            </div>
          </div>
        </div>
      ) : (
        image && <img className="fbpost__img" src={image} alt=""/>
      )
      }
    </div>
  )
}

export default FacebookPost


// WEBPACK FOOTER //
// ./src/components/campaigns/previews/FacebookPost.js